/* Infinite scroll for Empire 10 collection + search grids (added 2026-10-09).
 * Progressive enhancement: the server-rendered pagination stays in the DOM (crawlers / no-JS users),
 * JS hides it and loads the next page through the Section Rendering API when the user nears the end.
 * After each batch the section is re-initialised with Empire's own shopify:section:unload/load events
 * (the same path the theme editor uses), so new cards get quick-shop / quick-add / swatches / lazy images.
 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || !window.fetch || !window.DOMParser) return;

  var GRID_SEL = '[data-productgrid-items], ul.productgrid--items';
  var PAG_SEL = '.pagination--container';
  var NEXT_SEL = '.pagination--next a';

  function init() {
    var sectionRoot = document.querySelector('[data-section-type^="static-collection"], [data-section-type^="static-search"], [data-infinite-root]');
    if (!sectionRoot) return;
    var sectionEl = sectionRoot.parentNode; // div#shopify-section-...
    var sectionId = sectionRoot.getAttribute('data-section-id');
    var grid = sectionEl.querySelector(GRID_SEL);
    var pagination = sectionEl.querySelector(PAG_SEL);
    if (!grid || !pagination) return;
    var nextLink = pagination.querySelector(NEXT_SEL);
    var currentPage = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10) || 1;

    // Hide (not remove) the numbered pagination.
    pagination.setAttribute('data-infinite-hidden', '');
    pagination.style.display = 'none';

    // Sort / view-toggle / filter changes in Empire build the new URL from window.location, which would
    // keep our ?page=N. Drop it first (capture phase runs before the theme handlers) so they reset to page 1.
    function dropPageParam() {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('page')) return;
      u.searchParams.delete('page');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    }
    function isGridControl(t) {
      if (!t || !t.closest) return false;
      if (t.closest('[data-productgrid-sort-content], [data-productgrid-trigger-sort], [data-collection-view]')) return true;
      return sectionEl.contains(t) && !grid.contains(t) && !t.closest('.modal, [data-quickshop-full], [data-quickshop-slim]');
    }
    ['change', 'keyup'].forEach(function (type) {
      document.addEventListener(type, function (e) { if (isGridControl(e.target)) dropPageParam(); }, true);
    });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-collection-view], [data-productgrid-trigger-sort-button]');
      if (t) dropPageParam();
    }, true);

    var seen = {};
    function keyOf(li) {
      // Product cards have no handle attribute in Empire 10; key on the /products/<handle> part of the link.
      var a = li.querySelector('a[href*="/products/"]') || li.querySelector('a[href]');
      if (!a) return null;
      var href = a.getAttribute('href').split('?')[0].split('#')[0];
      var i = href.indexOf('/products/');
      return 'p:' + (i >= 0 ? href.slice(i) : href);
    }
    Array.prototype.forEach.call(grid.children, function (li) { var k = keyOf(li); if (k) seen[k] = true; });

    // "Show earlier products" when the visitor lands on ?page=N (N > 1)
    if (currentPage > 1) {
      var firstUrl = new URL(window.location.href);
      firstUrl.searchParams.delete('page');
      var prev = document.createElement('div');
      prev.className = 'infinite-scroll__prev';
      prev.innerHTML = '<a href="' + firstUrl.pathname + firstUrl.search + '">&uarr; Show earlier products</a>';
      grid.parentNode.insertBefore(prev, grid);
    }

    if (!nextLink) return; // single page, nothing to load

    var status = document.createElement('div');
    status.className = 'infinite-scroll__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.innerHTML = '<span class="infinite-scroll__spinner" aria-hidden="true"></span><span class="infinite-scroll__text"></span>';
    pagination.parentNode.insertBefore(status, pagination);
    var statusText = status.querySelector('.infinite-scroll__text');
    // Opt-in "Load more" fallback button (brand collections, 2026-10-18): only when the section root has data-infinite-button.
    if (sectionRoot.hasAttribute('data-infinite-button')) {
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'infinite-scroll__more';
      moreBtn.textContent = sectionRoot.getAttribute('data-infinite-button') || 'Load more products';
      moreBtn.addEventListener('click', function () { loadNext(); });
      status.appendChild(moreBtn);
    }

    var nextUrl = nextLink.getAttribute('href');
    var loading = false;
    var failures = 0;

    // Build the next-page URL from the current URL (keeps sort_by, filters, q, grid_list) and only take the
    // page number from the theme's "next" link. Falls back to the link itself if it has no page number.
    function pageOf(url) { return parseInt(new URL(url, window.location.origin).searchParams.get('page') || '0', 10) || 0; }
    function withSection(url) {
      var n = pageOf(url);
      var u = n ? new URL(window.location.href) : new URL(url, window.location.origin);
      if (n) u.searchParams.set('page', n);
      u.searchParams.set('section_id', sectionId);
      u.hash = '';
      return u.toString();
    }

    function reinitSection() {
      try {
        var detail = { sectionId: sectionId };
        sectionEl.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: detail }));
        sectionEl.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: detail }));
      } catch (e) { /* keep cards usable as plain links */ }
      // Re-locate the (re-rendered) pagination in case the theme touched it; keep it hidden.
      pagination.style.display = 'none';
    }

    function finish(msg) {
      observer.disconnect();
      status.classList.remove('is-loading');
      statusText.textContent = msg || '';
      if (!msg) status.style.display = 'none';
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      status.classList.add('is-loading');
      statusText.textContent = '';
      var requested = nextUrl;
      fetch(withSection(requested), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector(GRID_SEL);
          var added = 0;
          if (newGrid) {
            // <noscript> fallbacks are parsed as real <img> by DOMParser and would download a second image per card.
            Array.prototype.forEach.call(newGrid.querySelectorAll('noscript'), function (n) { n.parentNode.removeChild(n); });
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(newGrid.children).forEach(function (li) {
              var k = keyOf(li);
              if (k && seen[k]) return; // never show a product twice
              if (k) seen[k] = true;
              frag.appendChild(document.importNode(li, true));
              added++;
            });
            grid.appendChild(frag);
          }
          var newNext = doc.querySelector(PAG_SEL + ' ' + NEXT_SEL);
          nextUrl = newNext ? newNext.getAttribute('href') : null;

          var p = pageOf(requested);
          if (p) {
            var cur = new URL(window.location.href);
            cur.searchParams.set('page', p);
            history.replaceState(history.state, '', cur.pathname + cur.search + cur.hash);
          }
          if (added) reinitSection();
          loading = false;
          failures = 0;
          status.classList.remove('is-loading');
          if (!nextUrl) { finish(''); return; }
          // If the sentinel is still visible (short batch / tall screen) keep going.
          requestAnimationFrame(function () {
            var rect = status.getBoundingClientRect();
            if (rect.top < window.innerHeight + 800) loadNext();
          });
        })
        .catch(function () {
          loading = false;
          failures++;
          status.classList.remove('is-loading');
          if (failures >= 2) {
            // Give up gracefully: show the normal pagination again.
            observer.disconnect();
            status.style.display = 'none';
            pagination.style.display = '';
          }
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
    }, { rootMargin: '0px 0px 800px 0px' });
    observer.observe(status);
  }

  function start() { requestAnimationFrame(function () { setTimeout(init, 0); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
